<template>
	<div class="buy-dialog-wrap">
		<CvipDialog @btnClick="payNow()" @close="close()" :widthnew="'790px'" :heightnew="'570px'" :title="title" :btnTxt="btnTxt">
			<p class="tit">选择会员卡套餐：</p>
			<ul class="card-list">
				<li class="card" v-for="(item, index) in cardData" :key="index" @click="chooseCard(index, item.type)" :class="{ active: item.type === chooseType }" >
					<div class="recommend-icon" v-if="item.recommend"></div>
					<p class="card-title">{{ item.name}}</p>
					<div class="price">
						<p class="now-price">￥<em>{{ item.price }}</em><span class="date-unit">{{ item.dateUnit }}</span></p>
						<span class="original" v-if="item.originPrice > item.price">原价￥{{ item.originPrice }}</span>
						<span class="original-icon" v-else></span>
						<span class="price-discount" v-if="item.discount">{{ item.discount }}</span>
					</div>
					<div class="dotted-line"></div>
					<p class="enjoy-privileges">{{ item.privilegesText }}</p>
				</li>
			</ul>
			<p class="tit pay-type-tit">请扫码支付：</p>
			<div class="pay-center">
				<div class="pay-qrcode">
					<div id="payqrcode"></div>
					<div class="refresh-code" v-if="expire" @click="refreshCode()">
						<div class="refresh-icon"></div>
						<p class="refresh-text">点击刷新</p>
					</div>
				</div>
				<div class="pay-info">
					<p class="discount-txt" v-show="discountMoney > 0">
						<span>折扣:</span>
						<span>已优惠{{discountMoney}}元</span>
					</p>
					<div class="dotted-line" v-show="discountMoney > 0"></div>
					<p class="discount-coupun"></p>
					<p class="meal-price">￥<span class="price">{{ showPrice }}.00</span></p>
					<p class="pay-type">
						<i class="pay pay-wx"></i>
						<i class="pay pay-alipay"></i>
						<span class="pay-text">均可扫码支付</span>
					</p>
					<p class="vip-agreement">
						支付即表示同意
						《<span class="argument" @click="showArgument">会员用户协议</span>》
					</p>
				</div>
			</div>
		</CvipDialog>
		<!-- m端支付提交数据form -->
		<form id="formid" name="form1" method="post" target="_self" action="">
			<input type="hidden" name="starttime" id="starttime" value="">
			<input type="hidden" name="endtime" id="endtime" value="">
			<input type="hidden" name="buyAccountId" id="buyAccountId" value="">
			<input type="hidden" name="merId" id="merId" value="">
			<input type="hidden" name="orderId" id="orderId" value="">
			<input type="hidden" name="orderMoney" id="orderMoney" value="">
			<input type="hidden" name="isBill" id="isBill" value="0">
			<input type="hidden" name="productName" id="productName" value="">
			<input type="hidden" name="productDesc" id="productDesc" value="">
			<input type="hidden" name="returnUrl" id="returnUrl" value="">
			<input type="hidden" name="notifyUrl" id="notifyUrl" value="">
			<input type="hidden" name="sign" id="sign" value="">
			<input type="hidden" name="platfrom" id="platfrom" value="">
			<input type="hidden" name="payfrom" id="payfrom" value="">
			<input type="hidden" name="wapbanklist" id="wapbanklist" value="0">
			<input type="hidden" name="balancePaid" id="balancePaid" value="">
			<input type="hidden" name="resumeTag" id="resumeTag" value="self_resume">
			<input type="hidden" name="accountType" id="accountType" value="">
			<input type="hidden" name="balanceType" id="balanceType" value="">
			<input type="hidden" name="IAPProductID" id="IAPProductID" value="">
			<input type="hidden" name="buyAccountId" id="buyAccountId" value="">
			<input type="hidden" name="extensionInfo" id="extensionInfo">
			<input type="hidden" name="cityId" id="cityId" value="">
			<input type="hidden" name="channelId" id="channelId" value="">
		</form>
	</div>
</template>

<script>
	import CvipDialog from "./common/CvipDialog";
	import { mapGetters } from 'vuex';
	import { getPrice, getpaycviporder, getOrderState, getShortURL } from '../../../../api/index.js';
	import QRCode from 'qrcodejs2';

	export default {
		name: 'BuyDialog',
		props: {
			cardChoose: {
				type: Number,
				default: 19
			},
			controlShow: {
				type: Boolean
			}
		},
		data () {
			return {
				title: '开通求职黄金VIP卡',
				btnTxt: '',
				cardData: [
					{
						type: 22,
						name: '7天体验版',
						price: 18,					// 现价
						originPrice: 18,			// 原价
						privilegesText: '简历置顶等多项特权',	// 特权描述
						dateUnit: '',
						discount: ''
					},
					{
						type: 19,					// 套餐类型
						name: '30天基础版',			  // 套餐标题
						price: 28,					// 现价
						originPrice: 72,			// 原价
						privilegesText: '简历置顶等多项特权',	// 特权描述
						recommend: true,				// 显示推荐icon
						dateUnit: '',
						discount: '4折'
					},
					{
						type: 20,
						name: '30天升级版',
						price: 60,					// 现价
						originPrice: 216,			// 原价
						privilegesText: '简历置顶等多项特权',	// 特权描述
						dateUnit: '',
						discount: '3折'
					},
					{
						type: 20,
						name: '30天升级版',
						price: 60,					// 现价
						originPrice: 216,			// 原价
						privilegesText: '简历置顶等多项特权',	// 特权描述
						dateUnit: '',
						discount: '3折'
					}
				],
				priceInfo: { },
				calculateObj: {
					// 结算详情
					total: '72.00', //总计金额
					// discount: true, // 限时优惠(false则不展示)
					preferntial: '10.00', //减10元
					preReeson: '20', //满20元
					totalPref: '43', //共优惠53元
					finalPrice: 18
				},
				payTypes: [
					// 支付方式
					{
						type: 121,
						desc: '微信支付'
					},
					{
						type: 33,
						desc: '支付宝支付'
					},
					{
						type: 'other',
						desc: '其它支付方式'
					}
				],
				chooseType: this.cardChoose,// 选中的会员卡类别
				active: 1,					// 套餐index
				qrcode: null,				// 二维码
				expire: false, 				// 二维码过期
				timer: 0,  					// 过期定时器
				expireTime: 1800000, 		// 过期时间  (30分钟)
				orderStateTime: 3000, 		// 查询订单状态 循环时间
				getOrderStateTimer: 1, 		// 查询订单的定时器
				firstTime: 0, 				// 判断二维码是否是首次渲染
				payChoose: 'other', 		// 其它支付方式  33:支付宝支付   121:微信支付
				state: '',					// 会员开通状态	0-未开通  1-使用中   2-已过期
				ft: 'pc',
				showPrice: 28,				// 展示价格
			}
		},
		created () {
			// 获取价格
			this.getPriceFn();
			// 首次渲染
			this.firstTimeRender();
			// 埋点
			window.clickLog && window.clickLog('from=pc-cvip-buy-show-new');
		},
		destroyed() {
			window.clearInterval(this.getOrderStateTimer);
		},
		methods: {
			// 查询订单状态
			orderState(orderId){
				// 先清除定时器
				clearInterval(this.getOrderStateTimer);
				// 创建定时器
				this.getOrderStateTimer = setInterval(() => {
					getOrderState(orderId).then(res => {
						if(res.returnMessage === '支付成功') document.location.reload();
					})
				}, this.orderStateTime);
			},
			chooseCard (index, type) {
				if (index === this.active) return ;
				window.clickLog && window.clickLog(`from=pc-cvip-buyshow-${type}-dj-new`);
				this.chooseType = type;
				// 选中
				this.active = index;
				// 处理展示价格
				this.showPrice = this.cardData[index].price;
				this.getpaycviporderFn(this.state, this.cardData[this.active].type, 'pc', this.fromSource, 'https://cvip.58.com/view/pc');
			},
			// 第一次渲染二维码
			firstTimeRender(){
				this.getQRCode();
			},
			// 首次生成二维码
			useQRCode(url){
				this.qrcode = new QRCode('payqrcode', {
					text: url, //url
					width: 120,
					height: 120,
					correctLevel : QRCode.CorrectLevel.L
				});
				// 首次渲染 设置过期时间
				this.timer = setTimeout(() => {
					this.expire = true;
				}, this.expireTime)
			},
			// 刷新二维码
			refreshCode(){
				this.getQRCode();
				// 重新生成过期时间
				this.expire = false;
				this.timer = setTimeout(() => {
					this.expire = true;
				}, this.expireTime)
			},
			getQRCode(){
				this.getpaycviporderFn(this.state, this.cardData[this.active].type, 'pc', this.fromSource, 'https://cvip.58.com/view/pc')
			},
			// 点击生成二维码
			newQRCode(url){
				// 重新生成过期时间
				this.expire = false;
				// 清除定时器
				clearTimeout(this.timer);
				this.timer = setTimeout(() => {
					this.expire = true;
				}, this.expireTime)

				// 先清除二维码
				this.qrcode.clear();
				// 重新生成二维码
				this.qrcode.makeCode(url);
			},
			chosePayWay (type) {
				window.clickLog && window.clickLog(`from=pc-cvip-buyshow-${type}-dj-new`)
				if (type === this.payChoose) {
					return
				}
				this.payChoose = type
			},
			// 初始化优惠券
			initCoupon(){
				// 初始化数据
				// adSource:	产品线
				// source: 		来源
				// CateLevel:   类目级别
				// isdisplayCate:
				// cityLevel:
				// callBack:
				// usableType
				let couponData = {
					adSource: 30,
					source: 0,
					CateLevel: 1,
					isdisplayCate: 1,
					cityLevel: 0,
					callBack: this.couponCallback
				}
				this.coupon = new window.Coupon(couponData);
			},
			// 展示会员协议
			showArgument(){
				// this.$emit('showHyxy');
				window.clickLog && window.clickLog('from=pc-cvip-chooseCoupon-new');
				// 不展示弹窗了，改为跳转会员协议落地页
				window.open('https://helps.58.com/rules/detail?siteId=5502&terminal=PC&contentId=316237&sourceType=58pc-about&spReturn=1');
			},
			calculate (type) {
				// 结算规则
				switch (type)
				{
					case 7:
						this.calculateObj.total = '18.00'
						this.calculateObj.finalPrice = this.Cards[0].price
						this.calculateObj.totalPref = this.calculateObj.total - this.calculateObj.finalPrice
						break;
					case 8:
						this.calculateObj.total = '72.00'
						this.calculateObj.finalPrice = this.Cards[1].price
						this.calculateObj.totalPref = this.calculateObj.total - this.calculateObj.finalPrice
						break;
					case 9:
						this.calculateObj.total = '216.00'
						this.calculateObj.finalPrice = this.Cards[2].price
						this.calculateObj.totalPref = this.calculateObj.total - this.calculateObj.finalPrice
						break;
					case 10:
						this.calculateObj.total = '432.00'
						this.calculateObj.finalPrice = this.Cards[3].price
						this.calculateObj.totalPref = this.calculateObj.total - this.calculateObj.finalPrice
						break;
					default:
						this.calculateObj.total = '00.00'
						this.calculateObj.totalPref = '0'
						this.calculateObj.finalPrice = 0
				}
			},
			// 点击支付按钮
			payNow () {
				window.clickLog && window.clickLog('from=pc-cvip-buyshow-ljzf-dj-new')
				// this.getpaycviporderFn(this.state, this.cardChosing, 'pc', this.fromSource, 'https://paycenter.58.com/pay')
			},
			close () {
				this.$emit('closeDialog');
				window.clickLog && window.clickLog('from=pc-cvip-buyshow-close-new')
			},
			getPriceFn () {

				/* 2019年09月09日 改套餐 start */
				// 求职会员状态  获取价格
				// const paySet = this.mealInfo.payset;
				// this.cardData[0].name = paySet.experienceName;
				// this.cardData[0].price = paySet.experienceVersionPrice;
				// this.cardData[0].type = paySet.experienceVersion;
				// this.cardData[0].originPrice = paySet.experienceVersionOldPrice;
				// this.cardData[1].name = paySet.basicName;
				// this.cardData[1].price = paySet.basicVersionPrice;
				// this.cardData[1].type = paySet.basicVersion;
				// this.cardData[1].originPrice = paySet.basicVersionOldPrice;
				// this.cardData[2].name = paySet.upgradeName;
				// this.cardData[2].price = paySet.upgradeVersionPrice;
				// this.cardData[2].type = paySet.upgradeVersion;
				// this.cardData[2].originPrice = paySet.upgradeVersionOldPrice;
				/** end */

				const paySet = this.mealInfo.payset;
				paySet.forEach((mealItem, index) => {
					// if(!this.cardData[index]) {
					// 	this.cardData.push(this.cardData[index - 1]);
					// }
					this.cardData[index].name = mealItem.versionName;
					this.cardData[index].price = mealItem.benefitsPrice;
					this.cardData[index].type = mealItem.vid;
					this.cardData[index].originPrice = mealItem.oldPrice;
					this.cardData[index].discount = mealItem.desc;
				})

				this.showPrice = this.cardData[this.active].price
			},
			getpaycviporderFn (state, vid, ft, from, rtnurl, couponCode = '') {//支付接口
				getpaycviporder(state, vid, ft, from, rtnurl, couponCode).then((result) => {
					if(result.isSuccess){
						var url = '';
						// URL拼接
						if(result.entity.reqStatus === 'success'){
							url = result.entity.reqUrl
						} else {
							this.expire = true
							return
						}
						// 第一次渲染二维码
						if(this.firstTime === 0){
							this.useQRCode(url);
							this.orderState(result.entity.orderId);
							this.firstTime++;
						} else {
							// 查询订单状态
							this.orderState(result.entity.orderId);
							this.showPrice = result.entity.orderMoney.toString().split('.')[0];
							// 生成二维码
							this.newQRCode(url);
						}
					} else {
						console.log('网络异常------getpaycviporder---result ')
					}
				}).catch((err) => {
					console.error(err, '网络异常------getpaycviporder')
				})
			},
			/**
			 * [goToMPayCenter PC端跳转收银台]
			 * @param  {[type]} data [description]
			 * @return {[type]}      [description]
			 */
			goToPCPayCenter (data) {
				document.getElementById('formid').action = data.action
				document.getElementById('starttime').value = data.startTime
				document.getElementById('endtime').value = data.endTime
				document.getElementById('buyAccountId').value = data.buyAccountId
				document.getElementById('merId').value = data.merId
				document.getElementById('orderId').value = data.orderId
				document.getElementById('orderMoney').value = data.orderMoney
				document.getElementById('isBill').value = data.isBill
				document.getElementById('platfrom').value = data.platFrom
				document.getElementById('payfrom').value = data.payFrom
				document.getElementById('productName').value = data.productName
				document.getElementById('productDesc').value = data.productDesc
				document.getElementById('returnUrl').value = data.returnUrl
				document.getElementById('notifyUrl').value = data.notifyUrl
				document.getElementById('balancePaid').value = data.balancePaid
				document.getElementById('sign').value = data.sign
				document.getElementById('balanceType').value = data.balanceType
				document.getElementById('IAPProductID').value = data.IAPProductID
				document.getElementById('buyAccountId').value = data.buyAccountId
				document.getElementById('extensionInfo').value = data.extensionInfo
				document.getElementById('cityId').value = data.cityId
				document.getElementById('channelId').value = this.payChoose
				if(data.accountType && data.accountType != 0){
					document.getElementById('accountType').value = data.accountType
				}
				document.getElementById('formid').submit()
			}
		},
		components: {
			CvipDialog
		},
		computed: {
			...mapGetters({
				fromSource: 'fromSource',
				cvipMes: 'cvipMes',
				mealInfo: 'mealInfo',					// 购买套餐信息
			}),
			discountMoney() {
				const { originPrice, price } = this.cardData[this.active];
				return originPrice - price;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.buy-dialog-wrap {
		.card-list {
			width: 100%;
			margin-top: 10px;
			.card {
				width: 168px;
				height: 168px;
				border: 1px solid #EAEAEA;
				border-radius: 4px;
				text-align: center;
				margin: 5px 10px 0 0;
			}
			.card:last-child{
				margin-right: 0;
			}
			.active{
				background: #FDF7EB;
				border: 1px solid #C89543;
			}
		}
		.pay-type-tit{
			margin-top: 30px;
		}
		.card {
			position: relative;
			display: inline-block;
			vertical-align: middle;
			font-size: 0;
			cursor: pointer;
			.vipCards-card-heat {
				left: -4px;
				top: -4px;
				transform: scale(0.8);
			}
			.name {
				font-size: 18px;
				height: 28px;
				margin-top: 16px;
			}
			.card-title{
				margin-top: 20px;
				font-size: 18px;
				font-weight: bold;
				color: #333;
				letter-spacing: 0;
			}
			.price {
				font-size: 16px;
				margin-top: 16px;
				.now-price {
					color: #C89543;
					line-height: 24px;
					// font-weight: bold;
					font-size: 18px;
					em {
						font-size: 30px;
						font-style: normal;
					}
					.date-unit {
						font-size: 14px;
					}
				}
				.original {
					padding-top: 5px;
					font-size: 14px;
					text-decoration: line-through;
					color: #ccc;
				}
				.original-icon {
					display: inline-block;
					height: 20px;
				}
				.price-discount {
					display: inline-block;
					vertical-align: baseline;
					margin-top: 5px;
					// width: 28px;
					height: 15px;
					padding: 0 3px;
					line-height: 17px;
					background: #FFDC76;
					font-size: 12px;
					color: #8B610B;
					text-align: center;
				}
			}
			.dotted-line {
				margin: 11px auto;
				width: 140px;
				border-bottom: 1px dashed #EAEAEA;
			}
			.enjoy-privileges {
				margin-top: 10px;
				font-size: 14px;
				color: #C89543;
				letter-spacing: 0;
				text-align: center;
			}
			.recommend-icon{
				position: absolute;
				right: -5px;
				top: -5px;
				width: 52px;
				height: 24px;
				background: url(../../../../assets/imgs/icon-recoment.png) no-repeat center;
				background-size: 100% 100%;
			}
		}
		.calculate {
			line-height: 28px;
			margin-bottom: 18px;
			.preferTip {
				font-style: normal;
				font-size: 12px;
				color: #8b610b;
				background-color: #ffdc76;
				padding: 1px 2px;
			}
			.finalPrice {
				font-size: 18px;
				color: #333;
			}
		}
		.payWay {
			margin-top: 10px;
			display: inline-block;
			font-size: 0;
			user-select: none;
			cursor: pointer;
			.item {
				margin-right: 20px;
				display: inline-block;
				box-sizing: border-box;
				text-align: center;
				border: 1px solid #eaeaea;
				width: 150px;
				height: 40px;
				font-size: 14px;
				line-height: 38px;
				color: #333;
				font-weight: bold;
				border-radius: 2px;
			}
			.active{
				background: #FDF7EB;
				border: 1px solid #C89543;
			}
		}
		.pay-center{
			margin-top: 20px;
			.pay-qrcode{
				position: relative;
				display: inline-block;
				height: 120px;
				width: 120px;
				padding: 10px;
				border: 1px solid #EAEAEA;
				border-radius: 4px;
			}
			.refresh-code{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				opacity: .8;
				background: rgb(0, 0, 0);
				cursor: pointer;
			}
			.refresh-icon{
				margin: 48px auto 0 auto;
				width: 22px;
				height: 22px;
				background: url(../../../../assets/imgs/icon-refresh.png) no-repeat center;
				background-size: 100% 100%;
			}
			.refresh-text{
				margin-top: 5px;
				color: #fff;
				text-align: center;
			}
			.pay-info{
				width: 187px;
				// margin-top: 5px;
				margin-left: 30px;
				display: inline-block;
				vertical-align: top;
				font-size: 0;
				// float: right;
				.discount-txt {
					width: 100%;
					height: 20px;
					text-align: justify;
					font-size: 14px;
					color: #999;
					span:nth-child(1){
						float: left;
					}
					span:nth-child(2){
						float: right;
					}
				}
				.discount-coupun {
					width: 100%;
					height: 20px;
					text-align: justify;
					font-size: 14px;
					color: #999;
					span:nth-child(1){
						float: left;
					}
					span:nth-child(2){
						float: right;
						cursor: pointer;
						// text-decoration: underline;
					}
					.icon {
						margin-left: 5px;
						vertical-align: middle;
						display: inline-block;
						width: 12px;
						height: 12px;
						background: url(../../../../assets/imgs/icon-choarr.png) no-repeat center;
						background-size: 100% 100%;
					}
				}
				.dotted-line {
					margin: 5px 0 6px 0;
					width: 187px;
					border-bottom: 1px dashed #EAEAEA;
				}
				.discount{
					font-size: 14px;
					color: #999999;
				}
				.meal-price{
					margin-top: 5px;
					font-size: 18px;
					color: #C89543;
					.price{
						font-size: 30px;
					}
				}
				.pay-type{
					margin-top: 6px;
					.pay{
						display: inline-block;
						vertical-align: top;
						width: 18px;
						height: 18px;
						margin-right: 3px;
					}
					.pay-wx{
						background: url(../../../../assets/imgs/pay-wx.png) no-repeat center;
						background-size: 100% 100%;
					}
					.pay-alipay{
						margin-top: 1px;
						background: url(../../../../assets/imgs/pay-alipay.png) no-repeat center;
						background-size: 100% 100%;
					}
					.pay-text{
						font-size: 14px;
						color: #999999;
					}
				}
				.vip-agreement {
					margin-top: 6px;
					font-size: 12px;
					color: #ff552e;
    			font-weight: bold;
					span{
						cursor: pointer;
						text-decoration: underline;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// BuyDialog.vue?2fdd2256